<template>
  <div class="item" :class="{'height104': false}">
    <div class="left">
      <div class="coin-icon"></div>
    </div>
    <div class="center">
      <div class="title">{{ item.title }}</div>
      <div class="text">订单号：{{ item.orderMergeId }}</div>
      <div class="time">{{ item.gmtModified }}</div>
    </div>
    <div class="right">
      <span class="num" :class="{red: (item.amount<0)}">{{ item.amount }}枚</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      required: true,
    },
  },
  data() {
    return {
      item: {},
    }
  },
  watch: {
    itemData: {
      handler(newData, oldData) {
        this.item = newData
      },
      deep:true,
      immediate: true
    },
  },
  created() {

  },
  methods: {}
}
</script>

<style lang="less" scoped>
@url: 'https://fileqn.anttalk.vip/';
.item{
  height: 84px;display: flex;font-size: 12px;
  border-bottom: 1px solid #eee;
  &.height104{height: 104px;}
  &:last-child{
    border-bottom: none;
  }
  .left{
    width: 66px;height: 100%;
    display: inline-flex;justify-content: center;align-items: center;
    .coin-icon{
      width: 34px;height: 34px;
      background: url("@{url}FhDVrAmRGJixTrY99OsjuhItdSJv") no-repeat 50% 50%;
      background-size: 100%;
    }
  }
  .center{
    height: 100%;flex: 1;padding: 15px 0;color: #2b2b2b;
    display: flex;flex-direction: column;justify-content: space-between;
    .title{font-size: 16px;line-height: 1}
    .text{line-height: 1;}
    .time{line-height: 1;color: rgb(102,102,102);}
  }
  .right{
    width: 120px;height: 100%;padding-top: 15px;padding-right: 12px;
    line-height: 1;text-align: right;color: #2b2b2b;
    .num{
      max-width: 102px;
      white-space: pre-wrap;
      word-break:break-all;
      text-align: right;
    }
    .red{
      color: rgb(253,92,64);
    }
  }
}
</style>